<template>
    <div class="h-full h-10 w-10 flex items-center justify-center opportunity__table__item cursor-pointer rounded">
        <slot />
    </div>
</template>
